import { FC, useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom";
import { CommonHeader, useHeaderStore } from "../parts/CommonHeader";
import { isLoggedIn } from "../services/CookieHandler";
import { Subscription } from "../model/Subscription";
import { fetchAsync } from "../services/ApiHandler";
import { Toaster } from "react-hot-toast";
import { CommonFooter } from "../parts/CommonFooter";
import { DesktopSideNav } from "../parts/DesktopSideNav";

export const AccountLayout: FC = () => {
  const { setSubscription, fetchAccount, screenWidth } = useHeaderStore();
  const location = useLocation();

  if (!isLoggedIn()) {
    window.location.href = '/login';
  }

  useEffect(() => {
    if (!isLoggedIn()) return;
    fetchSubscription();
    fetchAccount();
  }, []);

  const fetchSubscription = async () => {
    const response = await fetchAsync<Subscription>('Subscription/GetActiveSubscription');
    setSubscription(response);
  };
  
  const isMobile = screenWidth < 640; // sm breakpoint
  const isGenerationHistoryPage = location.pathname === '/generation-history';
  const shouldHideHeader = isMobile && isGenerationHistoryPage;

  return  <>
    <Toaster />
    {!shouldHideHeader && <CommonHeader />}
    <div className="flex">
      <DesktopSideNav />
      <div className={`ml-0 flex-1 min-w-0 ${shouldHideHeader ? 'max-h-[100vh]' : 'max-h-[calc(100vh-76px)]'} overflow-scroll`}>
        <Outlet />
      </div>
    </div>
    <CommonFooter />
  </>
}
